import { DropdownMenu, IconButton } from '@nexelem/components';
import { ResourceGroup } from '@nexelem/graphne-api';
import { faRightLeftLarge } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type SelectResouceProps = {
  areas: ResourceGroup[];
  onSelect: (id: number) => void;
};

export const SelectResource = ({ areas, onSelect }: SelectResouceProps) => {
  const handleMenuItemClick = (id = 0) => {
    onSelect(id);
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <IconButton Icon={<FontAwesomeIcon icon={faRightLeftLarge} />} />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        {areas.map(({ name, id }) => (
          <DropdownMenu.Button key={name} onClick={() => handleMenuItemClick(id)}>
            {name}
          </DropdownMenu.Button>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
